import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
    breakpoints: breakpoints,
    mixins: mixins,
});

export const styles = {};

export const overrides = {
	'.callOut__section': {
		...mixins.layout_styles,

		'.callOut__image_right': {
			[theme.breakpoints.down('ms')]: {
				'div': {
					'&:nth-of-type(1)': {
						order: 2,
					},
					'&:nth-of-type(2)': {
						order: 1,
					}
				}
			}
		},

        '.callOut__image_wrapper': {
        	[theme.breakpoints.down('ms')]: {
        		marginBottom: remCalc(40),
        	},

        	'.callOut__image': {
        		width: '100%',
        		aspectRatio: '71/126',
        		backgroundSize: 'cover',
        		backgroundPosition: 'center',
        		backgroundRepeat: 'no-repeat',
        	}

        },

        '.callOut__content': {
        	display: 'flex',
        	flexDirection: 'column',
        	gap: remCalc(32),
        	[theme.breakpoints.up('ms')]: {
        		gap: remCalc(40),
        	},

        	'.callOut__pre-title': {
				fontFamily: 'var(--font-brandon-grotesque)',
				fontStyle: 'normal',
				fontWeight: 400,
				lineHeight: 1,
				letterSpacing: '0.5px',
				textTransform: 'uppercase',
				margin: 0,
			},

			'.callOut__title': {
				fontFamily: 'var(--font-brandon-grotesque)',
				fontStyle: 'normal',
				fontWeight: 400,
				lineHeight: 1,
				letterSpacing: '0.5px',
				textTransform: 'capitalize',
				margin: 0,
			},

			'.callOut__body': {
				fontWeight: 400,
				textTransform: 'none',
				fontStyle: 'italic',
			},

			'.callOut__link': {
				display: 'flex',
				flexDirection: 'column',
				gap: remCalc(30),
				justifyContent: 'center',
				alignItems: 'start',
				textDecoration: 'none',
				textTransform: 'uppercase',
				color: getColor('ivory', 700),

				'&:hover': {
					color: getColor('ivory', 700),
					textDecoration: 'none',
				},

				'&:focus-visible': {
					color: getColor('ivory', 700),
					textDecoration: 'none',
				},

				'.callOut__linkText': {
					display: 'inline-flex',
					alignItems: 'center',
					borderBottom: '1px solid transparent',
					transition: 'border-color 300ms ease',
				},

				'.callOut__linkText__label': {
					fontFamily: 'var(--font-brandon-grotesque)',
					fontSize: remCalc(16),
					fontStyle: 'normal',
					fontWeight: 420,
					lineHeight: 1.2,
					letterSpacing: remCalc(2),
					textTransform: 'uppercase',
				},

				'.callOut__linkText__arrow': {
					width: remCalc(47),
					height: remCalc(12),
					marginLeft: 0,
					transition: 'width var(--transition-duration) ease, margin-left var(--transition-duration) ease, opacity var(--transition-duration-slow) ease, transform var(--transition-duration) ease',

					'svg': {
						display: 'block',
						width: remCalc(47),
						height: remCalc(12),
					},

					'svg path': {
						fill: getColor('ivory', 700),
					},
				},

				'&:focus-visible .callOut__linkText': {
					borderBottom: `1px solid ${getColor('ivory', 700)}`,
				},


				'@media (hover: hover) and (pointer: fine)': {
					'&:hover .callOut__linkText': {
						borderBottom: `1px solid ${getColor('ivory', 700)}`,
					},
				},
			},
        },
	},
};

export default styles;